import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center",
  style: {"background-image":"url('bg.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = { class: "w-lg-450px bg-white rounded shadow-lg p-10 p-lg-15 mx-auto" }
const _hoisted_4 = { class: "text-center mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center w-100" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/logos/MB_logo_blue.png",
    class: "text-center",
    style: {"width":"35% !important"}
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { style: {"color":"#163578","font-size":"18px","font-weight":"600"} }
const _hoisted_8 = { style: {"color":"#163578"} }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Нэвтрэх ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { style: {"margin-top":"50px"} }
const _hoisted_21 = { style: {"color":"#163578"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmitLogin,
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_login__form",
          "validation-schema": _ctx.login
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.mainTitle), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h6", _hoisted_8, "v" + _toDisplayString(_ctx.version), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "Хэрэглэгчийн нэр",
                name: "username",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ErrorMessage, { name: "username" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                placeholder: "Нууц үг",
                name: "password",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", _hoisted_16, _hoisted_19, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h6", _hoisted_21, _toDisplayString(_ctx.copyRight), 1)
      ])
    ])
  ]))
}